import { AbsoluteFill, useCurrentFrame, interpolate, Easing } from "remotion";
import React from "react";

// VFX: Whip Pan Transition
// Category: slide-transition · Tags: transition, whip-pan, fast, reels, camera
const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;

export default function TransitionWhipPanFast250Ms() {
  const frame = useCurrentFrame();
  const duration = 8;
  const dir = -1; // left
  // Two halves: A panning out, B panning in
  const mid = duration / 2;
  const xA = interpolate(frame, [0, mid], [0, 400 * dir], { ...clamp, easing: Easing.in(Easing.cubic) });
  const xB = interpolate(frame, [mid, duration], [-400 * dir, 0], { ...clamp, easing: Easing.out(Easing.cubic) });
  const blur = interpolate(frame, [0, mid, duration], [0, 40, 0], clamp);
  const opacityA = interpolate(frame, [mid - 1, mid + 1], [1, 0], clamp);
  const opacityB = interpolate(frame, [mid - 1, mid + 1], [0, 1], clamp);

  return (
    <AbsoluteFill>
      <AbsoluteFill style={{
        background: "linear-gradient(135deg, #a855f7 0%, #06b6d4 100%)",
        transform: `translateX(${xA}px)`,
        filter: `blur(${blur}px)`,
        opacity: opacityA,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <span style={{ color: "#fff", fontSize: 96, fontWeight: 900, letterSpacing: "0.05em" }}>A</span>
      </AbsoluteFill>
      <AbsoluteFill style={{
        background: "linear-gradient(135deg, #f97316 0%, #ef4444 100%)",
        transform: `translateX(${xB}px)`,
        filter: `blur(${blur}px)`,
        opacity: opacityB,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <span style={{ color: "#fff", fontSize: 96, fontWeight: 900, letterSpacing: "0.05em" }}>B</span>
      </AbsoluteFill>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
